// Errori dell'accesso con Google o Microsoft. Quando l'accesso non va a buon
// fine, sync-channel riporta il cliente al pannello con
// `?auth=error&reason=<codice>` (src/auth/gmail/gmail-auth-handler.ts,
// src/auth/outlook/outlook-auth-handler.ts, src/index.ts). Qui ogni codice
// diventa una spiegazione in parole semplici; un codice nuovo che il pannello
// non conosce ancora riceve il messaggio generico, mai il silenzio.
const KEY_PREFIX = 'INBOX_MGMT.OAUTH_ERROR';

export const OAUTH_ERROR_REASONS = Object.freeze({
  // Il cliente ha premuto "Annulla" o non ha dato il permesso.
  authorization_denied: 'CONSENT_DENIED',
  // Microsoft aziendale: serve l'ok di chi gestisce gli account dell'hotel.
  admin_consent_required: 'ADMIN_CONSENT_REQUIRED',
  // Accesso fatto con una casella diversa da quella scritta.
  mailbox_identity_unverified: 'MAILBOX_MISMATCH',
  mailbox_mismatch: 'MAILBOX_MISMATCH',
  // Collegamento scaduto, riaperto da un'altra finestra o gia' usato.
  missing_state: 'EXPIRED',
  invalid_state: 'EXPIRED',
  missing_code: 'EXPIRED',
  // L'utente non e' piu' nell'account (o l'account non e' attivo).
  authorization_revoked: 'ACCESS_REVOKED',
  // La casella e' gia' collegata in un altro modo o su un altro account.
  provider_conflict: 'PROVIDER_CONFLICT',
  // La casella da ricollegare non c'e' piu' o e' cambiata nel frattempo.
  channel_not_found: 'CHANNEL_CHANGED',
  channel_ambiguous: 'CHANNEL_CHANGED',
  channel_binding_changed: 'CHANNEL_CHANGED',
  // Google o Microsoft non hanno risposto come dovevano.
  token_exchange_failed: 'PROVIDER_FAILED',
  user_info_failed: 'PROVIDER_FAILED',
  oauth_failed: 'PROVIDER_FAILED',
});

// Il modulo della casella mostra gia' da se' questi due motivi, accanto al
// campo dell'indirizzo (Email.vue): li' l'avviso generale sarebbe un doppione.
const REASONS_SHOWN_BY_EMAIL_SETUP = [
  'mailbox_mismatch',
  'mailbox_identity_unverified',
];
const EMAIL_SETUP_ROUTE = 'settings_inboxes_page_channel';

const firstValue = (value) => (Array.isArray(value) ? value[0] : value);

export function oauthErrorFromQuery(query) {
  if (firstValue(query?.auth) !== 'error') return null;

  const rawReason = firstValue(query?.reason);
  const reason = typeof rawReason === 'string' ? rawReason : '';
  const kind = Object.prototype.hasOwnProperty.call(OAUTH_ERROR_REASONS, reason)
    ? OAUTH_ERROR_REASONS[reason]
    : 'PROVIDER_FAILED';

  return {
    reason,
    kind,
    titleKey: `${KEY_PREFIX}.TITLE`,
    messageKey: `${KEY_PREFIX}.${kind}`,
    hintKey:
      kind === 'ADMIN_CONSENT_REQUIRED'
        ? `${KEY_PREFIX}.ADMIN_CONSENT_IT_HINT`
        : null,
  };
}

// Solo `auth` e `reason`: servono al router per non perderli quando porta
// `/?auth=error...` alla pagina iniziale dell'account.
export function oauthErrorQuery(query) {
  if (firstValue(query?.auth) !== 'error') return null;

  const reason = firstValue(query?.reason);
  return typeof reason === 'string' && reason
    ? { auth: 'error', reason }
    : { auth: 'error' };
}

export function withoutOAuthErrorQuery(query = {}) {
  const { auth, reason, ...rest } = query || {};
  return rest;
}

export function isOAuthErrorShownByPage(route, error) {
  return (
    route?.name === EMAIL_SETUP_ROUTE &&
    REASONS_SHOWN_BY_EMAIL_SETUP.includes(error?.reason)
  );
}
